import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { AuthProvider } from './contexts/AuthContext.tsx';
import { LoaderProvider } from './contexts/LoaderContext.tsx';
import { registerSW } from 'virtual:pwa-register';

createRoot(document.getElementById("root")!).render(
    <LoaderProvider>
        <AuthProvider>
            <App />
        </AuthProvider>
    </LoaderProvider>
);

// Register service worker without caching (SW is generated but contains no caching strategies)
registerSW({ immediate: true });